/**
 * Date-extensions locale Icelandic [is]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('is', {
    monthNames: ['Janúar','Febrúar','Mars','Apríl','Maí','Júní','Júlí','ágúst','September','Október','Nóvember','Desember'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Maí','Jún','Júl','ágú','Sep','Okt','Nóv','Des'],
    dayNames: ['Sunnudagur','Mánudagur','þriðjudagur','Miðvikudagur','Fimmtudagur','Föstudagur','Laugardagur'],
    dayShortNames: ['Sun','Mán','þri','Mið','Fim','Fös','Lau']
});
